import React from 'react';
import { BookOpenIcon, BeakerIcon, ClipboardCheckIcon, HeartIcon, UsersIcon } from 'lucide-react';
export const TrustFooter = () => {
  return <section className="mt-12 mb-8" data-id="element-3923">
      <h2 className="text-2xl font-serif font-bold text-slate-900 mt-10 mb-5 leading-tight border-b border-slate-200 pb-2 flex items-center" data-id="element-3924">
        <BookOpenIcon className="h-5 w-5 text-slate-700 mr-2 inline" data-id="element-3925" />
        Our Commitment to Evidence-Based Information
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-3926">
        {/* Research Methodology */}
        <div className="bg-white p-5 rounded-lg border border-slate-200 hover:shadow-md transition-shadow duration-300" data-id="element-3927">
          <div className="flex items-center mb-4" data-id="element-3928">
            <div className="w-14 h-14 bg-indigo-100 rounded-full flex items-center justify-center mr-4" data-id="element-3929">
              <BeakerIcon className="h-7 w-7 text-indigo-700" data-id="element-3930" />
            </div>
            <div data-id="element-3931">
              <h3 className="font-serif font-semibold text-slate-900 text-lg" data-id="element-3932">
                Research Methodology
              </h3>
              <p className="text-sm text-slate-600" data-id="element-3933">
                How we evaluate and interpret scientific evidence
              </p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-3934">
            <p className="text-sm text-slate-700" data-id="element-3935">
              Our content is based on rigorous scientific research published in
              peer-reviewed journals. We prioritize randomized controlled
              trials, systematic reviews, and meta-analyses while considering
              study limitations and potential biases.
            </p>
            <div className="mt-3 flex items-center" data-id="element-3936">
              <span className="text-xs text-slate-500" data-id="element-3937">
                Learn more about our scientific standards →
              </span>
            </div>
          </div>
        </div>
        {/* Editorial Process */}
        <div className="bg-white p-5 rounded-lg border border-slate-200 hover:shadow-md transition-shadow duration-300" data-id="element-3938">
          <div className="flex items-center mb-4" data-id="element-3939">
            <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-3940">
              <ClipboardCheckIcon className="h-7 w-7 text-blue-700" data-id="element-3941" />
            </div>
            <div data-id="element-3942">
              <h3 className="font-serif font-semibold text-slate-900 text-lg" data-id="element-3943">
                Editorial Process
              </h3>
              <p className="text-sm text-slate-600" data-id="element-3944">
                How we ensure accuracy and clarity in our content
              </p>
            </div>
          </div>
          <div className="mt-4 pt-4 border-t border-slate-100" data-id="element-3945">
            <p className="text-sm text-slate-700" data-id="element-3946">
              All content undergoes a rigorous multi-stage review process
              including fact-checking by medical experts, scientific accuracy
              verification, and readability assessment to ensure complex topics
              are explained in accessible language.
            </p>
            <div className="mt-3 flex items-center" data-id="element-3947">
              <span className="text-xs text-slate-500" data-id="element-3948">
                Meet our editorial team and reviewers →
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Expert Contributors */}
      <div className="bg-slate-50 rounded-lg border border-slate-200 p-6 mb-8" data-id="element-3949">
        <div className="text-center mb-6" data-id="element-3950">
          <h3 className="font-serif font-semibold text-slate-900 text-lg" data-id="element-3951">
            Our Expert Contributors
          </h3>
          <p className="text-sm text-slate-600 mt-1" data-id="element-3952">
            Content is reviewed and contributed to by specialists in women's
            health
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4" data-id="element-3953">
          <div className="bg-white p-4 rounded border border-slate-200 text-center hover:border-indigo-300 hover:shadow-sm transition-all duration-300" data-id="element-3954">
            <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-3955">
              <UsersIcon className="h-6 w-6 text-indigo-700" data-id="element-3956" />
            </div>
            <div className="text-sm font-medium text-slate-900 mb-1" data-id="element-3957">
              OB/GYNs
            </div>
            <div className="text-xs text-slate-600" data-id="element-3958">
              Board-certified specialists in women's reproductive health
            </div>
          </div>
          <div className="bg-white p-4 rounded border border-slate-200 text-center hover:border-rose-300 hover:shadow-sm transition-all duration-300" data-id="element-3959">
            <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-3960">
              <BeakerIcon className="h-6 w-6 text-rose-700" data-id="element-3961" />
            </div>
            <div className="text-sm font-medium text-slate-900 mb-1" data-id="element-3962">
              Researchers
            </div>
            <div className="text-xs text-slate-600" data-id="element-3963">
              PhD scientists specializing in microbiology and women's health
            </div>
          </div>
          <div className="bg-white p-4 rounded border border-slate-200 text-center hover:border-blue-300 hover:shadow-sm transition-all duration-300" data-id="element-3964">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-3965">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-blue-700" data-id="element-3966">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="currentColor" data-id="element-3967" />
              </svg>
            </div>
            <div className="text-sm font-medium text-slate-900 mb-1" data-id="element-3968">
              Endocrinologists
            </div>
            <div className="text-xs text-slate-600" data-id="element-3969">
              Hormone specialists with expertise in menopausal health
            </div>
          </div>
          <div className="bg-white p-4 rounded border border-slate-200 text-center hover:border-green-300 hover:shadow-sm transition-all duration-300" data-id="element-3970">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-3971">
              <HeartIcon className="h-6 w-6 text-green-700" data-id="element-3972" />
            </div>
            <div className="text-sm font-medium text-slate-900 mb-1" data-id="element-3973">
              Women's Health NPs
            </div>
            <div className="text-xs text-slate-600" data-id="element-3974">
              Nurse practitioners specializing in comprehensive women's care
            </div>
          </div>
        </div>
      </div>
      {/* Content Standards */}
      <div className="bg-white rounded-lg border border-slate-200 p-5" data-id="element-3975">
        <h3 className="font-serif font-semibold text-slate-900 text-lg mb-4 border-b border-slate-100 pb-2" data-id="element-3976">
          Our Content Standards
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3977">
          <div className="flex items-start" data-id="element-3978">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3979">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-indigo-700" data-id="element-3980">
                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor" data-id="element-3981" />
              </svg>
            </div>
            <div data-id="element-3982">
              <h4 className="text-sm font-medium text-slate-900 mb-1" data-id="element-3983">
                Evidence-Based
              </h4>
              <p className="text-xs text-slate-600" data-id="element-3984">
                All information is supported by current scientific research from
                reputable sources
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3985">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3986">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-indigo-700" data-id="element-3987">
                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor" data-id="element-3988" />
              </svg>
            </div>
            <div data-id="element-3989">
              <h4 className="text-sm font-medium text-slate-900 mb-1" data-id="element-3990">
                Regularly Updated
              </h4>
              <p className="text-xs text-slate-600" data-id="element-3991">
                Content is reviewed and revised to reflect the latest scientific
                understanding
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3992">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-3993">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-indigo-700" data-id="element-3994">
                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor" data-id="element-3995" />
              </svg>
            </div>
            <div data-id="element-3996">
              <h4 className="text-sm font-medium text-slate-900 mb-1" data-id="element-3997">
                Transparent
              </h4>
              <p className="text-xs text-slate-600" data-id="element-3998">
                We clearly cite sources and disclose limitations of current
                research
              </p>
            </div>
          </div>
          <div className="flex items-start" data-id="element-3999">
            <div className="w-8 h-8 bg-indigo-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0" data-id="element-4000">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-indigo-700" data-id="element-4001">
                <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="currentColor" data-id="element-4002" />
              </svg>
            </div>
            <div data-id="element-4003">
              <h4 className="text-sm font-medium text-slate-900 mb-1" data-id="element-4004">
                Accessible
              </h4>
              <p className="text-xs text-slate-600" data-id="element-4005">
                Complex medical concepts are explained in clear, understandable
                language
              </p>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-slate-100 text-center text-xs text-slate-500" data-id="element-4006">
          Our content is for educational purposes only and is not a substitute
          for professional medical advice. Always consult with a healthcare
          provider for personalized recommendations.
        </div>
      </div>
    </section>;
};